import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // I don't know why, but the scroll is not working without setTimeout in some cases
    setTimeout(() => window.scrollTo(0, 0), 10);
  }, [location.pathname]);

  return children;
};

export default ScrollToTop;
